module.exports = __webpack_public_path__ + "assets/img/chirp-profile-active.33da6803.svg";